import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import unauthorizedUsageInitialState from './unauthorized-usage-initial-state';
import { UnauthorizedUsageResponse } from '../models/unauthorizedUsage.model';
import { Dayjs } from 'dayjs';

const unauthorizedUsageSlice = createSlice({
    name: 'unauthorizedUsageSlice',
    initialState: unauthorizedUsageInitialState,
    reducers: {
        setUnauthorizedUsageData(state, { payload }: PayloadAction<UnauthorizedUsageResponse[]>) {
            state.data = payload;
        },
        clearUnauthorizedUsageData(state) {
            state.data = [];
        },
        setCompanies(state, { payload }: PayloadAction<string[]>) {
            state.companies = payload;
        },
        setDepartments(state, { payload }: PayloadAction<string[]>) {
            state.departments = payload;
        },
        setForklifts(state, { payload }: PayloadAction<string[]>) {
            state.forklifts = payload;
        },
        setShowFilters(state, { payload }: PayloadAction<boolean>) {
            state.showFilters = payload;
        },
        setStartDateDayJS(state, { payload }: PayloadAction<Dayjs>) {
            state.startDate = payload;
        },
        setEndDateDayJS(state, { payload }: PayloadAction<Dayjs>) {
            state.endDate = payload;
        },
    }
});

export const {
    setUnauthorizedUsageData,
    clearUnauthorizedUsageData,
    setCompanies,
    setDepartments,
    setForklifts,
    setShowFilters,
    setStartDateDayJS,
    setEndDateDayJS,
} = unauthorizedUsageSlice.actions;

export default unauthorizedUsageSlice.reducer;
